import React, { Component } from "react";
import "styled-components/macro";

import listenKeyboardShortcuts from "./utils/listen-keyboard-shortcuts";
import removeKeyboardListeners from "./utils/remove-keyboard-listeners";

export default class TrailerVideoModal extends Component {
  kbs = null;

  render() {
    const { handleCloseTrailerVideo, isTrailerVideoOpen, desktopWidth } =
      this.props;

    return isTrailerVideoOpen ? (
      <div
        css={`
          z-index: 1000;
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: hsl(240deg 70% 1% / 92%);
          backdrop-filter: blur(2px);
        `}
        onClick={handleCloseTrailerVideo}
      >
        <div
          css={`
            position: relative;
            overflow: hidden;
            width: 100%;
            max-width: 90vw;
            max-height: 90vh;
            border-radius: 7px;
            &::after {
              display: block;
              content: "";
              padding-top: 56.25%;
            }
          `}
        >
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/7Gj72YWPavE?si=8izyCmn7fxwlYy1k&autoplay=1&mute=0"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            css={`
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            `}
          />
        </div>
        {/* <button onClick={handleCloseTrailerVideo}>Close</button> */}
      </div>
    ) : null;
  }

  componentDidMount() {
    this.listenToKbs()
  }

  componentWillUnmount() {
    this.kbs = removeKeyboardListeners(this.kbs);
  }

  listenToKbs = () => {
    this.kbs = listenKeyboardShortcuts(
      [
        {
          key: "Escape",
          modifiers: {
            ctrlKey: false,
            altKey: false,
            metaKey: false,
            shiftKey: false,
          },
          fn: this.props.handleCloseTrailerVideo,
        },
      ],
      "keydown",
      true
    );
  };
}
